import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import { PartnerSettingsPage } from "@/pages/partner/PartnerAccountPages";

export const Route = createFileRoute("/partner/settings")({
  head: () => pageHead("Partner Settings", "Sign-in, security and display settings for the AKIVA Partner workspace.", "/partner/settings", true),
  component: PartnerSettingsPage,
});
